import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { ContainerSizeType } from 'src/app/models/container_master_model/sizeType';
import { BackendListModel } from '../../models/common/list.model';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ContainerModel } from 'src/app/models/container_master_model/container-model';
import { LifeCycleModel } from 'src/app/models/common/lifecycle';
import { LifeCycleMasterModel } from 'src/app/models/lifecyclemaster';
import { ContainerGradeModel } from 'src/app/models/container_master_model/container-grade-model';

@Injectable({
  providedIn: 'root'
})
export class ContainerMasterApiService {
  base_url = ApiRoutes.ContainerMaster;
  base_url1 = ApiRoutes.LeadRequest;
  latestBlockForCompany:any;
  containerObjData:any;

  constructor(
    private http: HttpClient
  ) { }

  getAllContainers(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ContainerModel>> {
    let url = `${this.base_url}all_container/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<ContainerModel>>(String(urlObj));
  }

  // GET Size and Type of Container
  getSizeType(): Observable<BackendListModel<ContainerSizeType>> {
    let url = `${this.base_url}container_size_type/`;
    return this.http.get<BackendListModel<ContainerSizeType>>(url);
  }

  // GET Smart Device Name
  getDeviceByName(): Observable<BackendListModel<ContainerModel>> {
    let url = `${this.base_url}container_device/`
    return this.http.get<BackendListModel<ContainerModel>>(url);
  }

  // POST Container Master Data
  // postContainerData(data: any) {
  //   let url = `${this.base_url}single_entry/`;
  //   this.http.post<ContainerModel>(url, data).subscribe({
  //     next: (response) => console.log(response),
  //     error: (error) => console.log(error)
  //   });
  // }

  // POST Container Information
  postContainerData(container: ContainerModel) {
    let url = `${this.base_url}single_entry/`;
    console.log("service entry", container);
    // return new Observable()
    return this.http.post(url, container);
  }

  // GET Container Information by ID
  getContainerDataById(id: any): Observable<ContainerModel> {
    let url = `${this.base_url}${id}/`;
    return this.http.get<ContainerModel>(url);
  }

  // PUT (update) Container Information
  updateContainerData(container: ContainerModel) {
    let url = `${this.base_url}single_entry/${container.id}/`;
    return this.http.put(url, container);
  }

  // GET Container LifeCycle Information
  getLifeCycleListData(containerId: any): Observable<BackendListModel<LifeCycleModel>> {
    let url = `${this.base_url}container_lifecycle/list/${containerId}/`;
    return this.http.get<BackendListModel<LifeCycleModel>>(url);
  }

  // POST Container LifeCycle Information
  postLifeCycleListData(containerId: any, lifeData: LifeCycleModel) {
    let url = `${this.base_url}container_lifecycle/list/${containerId}/`;
    return this.http.post(url, lifeData);
  }

  // PUT (update) Container LifeCycle Information
  updateContainerLifeCycleDetails(containerId: any, lifeData: LifeCycleModel) {
    let url = `${this.base_url}container_lifecycle/${containerId}/`;
    return this.http.put(url, lifeData);
  }

  // GET LifeCycle Master data
  getLifeCycleMasterDetails(container_id, page_size = 50): Observable<BackendListModel<LifeCycleMasterModel>> {
    let url = `${this.base_url}life_cycle_master/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('container_id', String(container_id));
    urlObj.searchParams.append('page_size', String(page_size));

    return this.http.get<BackendListModel<LifeCycleMasterModel>>(String(urlObj));
  }

  // GET Container Validity
  checkContainerValidity(container_number: string) {
    let url = `${this.base_url}validity/?container_number=${container_number}`;
    return this.http.get(url);
  }

  // GET Container Grade
  getContainerGrade(data): Observable<ContainerGradeModel> {
    let url = `${this.base_url}grade-by-manufacturing-date/`;
    return this.http.post<ContainerGradeModel>(url, data);
  }

  getBookingDetails(contid) {
    let url = `${this.base_url1}request_details/latest_for_container/${contid}/`;
    return this.http.get(url);
  }
  getAllLifecycleList(containerId: any,page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<LifeCycleModel>> {
    let url = `${this.base_url}container_booking_history/${containerId}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<LifeCycleModel>>(String(urlObj));
  }
  // ?is_temporary_allocation=false
  getAllNewContainerLifecycleList(containerId: any,page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<LifeCycleModel>> {
    let url = `${this.base_url}new_container_lifecycle/${containerId}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<LifeCycleModel>>(String(urlObj));
  }
  // POST Container LifeCycle Information
  postLifeCycleList(containerId: any, lifeData: LifeCycleModel) {
    let url = `${this.base_url}new_container_lifecycle/${containerId}/`;
    return this.http.post(url, lifeData);
  }

}
